const snackbar = {
  MuiSnackbar: {
    styleOverrides: {
      root: {
        '&.MuiSnackbar-anchorOriginBottomLeft': {
          left: 0,
        },
      },
    },
  },
}

export default snackbar
